module.exports = __webpack_public_path__ + "img/traffic4.e06fd4f9.png";